module.exports = __webpack_public_path__ + "static/media/logo.d2eae808.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/pages/assets/logo.png
// module id = 304
// module chunks = 0